import styled from '@emotion/styled';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Link } from 'react-router';

export interface CrumbPart {
  label: string;
  to?: string;
}

export interface CrumbWidgetProps {
  parts: Array<string | CrumbPart>;
  lastPartIsCurrentPage?: boolean;
}

export const CrumbWidget: React.FC<CrumbWidgetProps> = (props) => {
  if (!props.parts.length) {
    return null;
  }

  return (
    <S.Container>
      {props.parts.map((part, index) => {
        const resolvedPart = typeof part === 'string' ? { label: part } : part;

        const isLast = index === props.parts.length - 1;

        if (isLast && props.lastPartIsCurrentPage !== false) {
          return <S.PartFinal key={index}>{resolvedPart.label}</S.PartFinal>;
        }

        return (
          <React.Fragment key={index}>
            {resolvedPart.to ? (
              <S.PartLink to={resolvedPart.to}>{resolvedPart.label}</S.PartLink>
            ) : (
              <S.Part>{resolvedPart.label}</S.Part>
            )}
            {!isLast ? <S.Separator icon={faAngleRight} /> : null}
          </React.Fragment>
        );
      })}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    display: flex;
    align-items: center;
    column-gap: var(--breadcrumb-gap, 14px);
    flex-wrap: wrap;
  `;

  export const Part = styled.div`
    color: ${(p) => p.theme.text.paragraph};
    white-space: nowrap;
  `;

  export const PartLink = styled(Link)`
    color: ${(p) => p.theme.text.paragraph};
    white-space: nowrap;
    text-decoration: none;

    &:hover,
    &:focus-visible {
      color: ${(p) => p.theme.text.heading};
      text-decoration: underline;
    }
  `;

  export const PartFinal = styled.div`
    color: ${(p) => p.theme.text.heading};
  `;

  export const Separator = styled(FontAwesomeIcon)`
    color: ${(p) => p.theme.text.paragraph};
    opacity: 0.45;
    font-size: var(--breadcrumb-separator-size, 11px);
  `;
}
